module.exports = __webpack_public_path__ + "static/media/clocardslogo.7dcf17d7.png";